import { useState } from "react";
import { getAuth, updateProfile, updateEmail } from "firebase/auth";
import {
  Button,
  Container,
  Typography,
  FormControl,
  Input,
} from "@mui/material";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase.config";

import { toast } from "react-toastify";

function Profile() {
  const auth = getAuth();
  const [changeDetails, setChangeDetails] = useState(false);

  const [formData, setFormData] = useState({
    name: auth.currentUser.displayName,
    email: auth.currentUser.email,
  });

  const { name, email } = formData;

  const onSubmit = async () => {
    try {
      if (auth.currentUser.displayName !== name) {
        // Update display name in fb
        await updateProfile(auth.currentUser, {
          displayName: name,
        });
        // Update in firestore
        const userRef = doc(db, "users", auth.currentUser.uid);
        await updateDoc(userRef, {
          name,
        });
      }
      if (auth.currentUser.email !== email) {
        try {
          const user = auth.currentUser;
          await updateEmail(user, email);
          const userRef = doc(db, "users", auth.currentUser.uid);
          await updateDoc(userRef, {
            email,
          });
          console.log("email changed");
        } catch (error) {
          console.log("error :", error);
        }
      }
    } catch (error) {
      console.log("error :", error);
      toast.error("Could not update profile details");
    }
    console.log(123);
  };

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  return (
    <Container>
      <div>
        <header>
          <Typography variant="h2" component="h1">
            My Profile
          </Typography>
        </header>
        <main>
          <div style={{ display: "flex" }}>
            <Typography variant="h6" component="h2">
              Personal Details
            </Typography>
          </div>
          <div
            style={{ display: "flex", flexDirection: "column" }}
            className="profileCard"
          >
            <form
              style={{
                minWidth: "500px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <FormControl>
                <label htmlFor="name">Your Name:</label>
                <Input
                  type="text"
                  id="name"
                  disabled={!changeDetails}
                  value={name}
                  onChange={onChange}
                />
              </FormControl>
              <FormControl>
                <label htmlFor="email">Your Email:</label>
                <Input
                  type="email"
                  id="email"
                  className={`profileEmail ${
                    changeDetails && "profileEmailAcitve"
                  }`}
                  disabled={!changeDetails}
                  value={email}
                  onChange={onChange}
                />
              </FormControl>
            </form>
            <Button
              className="changePersonalDetails"
              color="secondary"
              variant="contained"
              sx={{
                marginTop: "10px",
                alignSelf: "flex-start",
                textTransform: "none",
              }}
              onClick={() => {
                changeDetails && onSubmit();
                setChangeDetails((prevState) => !prevState);
              }}
            >
              {changeDetails ? "Done" : "Change"}
            </Button>
          </div>
        </main>
      </div>
    </Container>
  );
}

export default Profile;
